import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import DeleteIcon from "../../assets/icons/delete";
import LikeIcon from "../../assets/icons/thumbsUpOutlined";
import EditIcon from "../../assets/icons/edit";
import ShareIcon from "../../assets/icons/share";
import { editStoryRoute, storyDetailsRoute } from "../../routes/routesPath";
import { successMsg } from "../../utils/toastMessage";
import { getSlug } from "../../utils/helpers";
import { handleApiRequest } from "../../services/handleApiRequest";
import { updateStoriesList } from "../../redux/stories/slice";
import { deleteStory } from "../../redux/stories/thunk";
import StoryCardHeader from "./storyCardHeader";
import DeletePopup from "../Modals/deletePop";
import SharePop from "../Modals/sharePop";
import ReportStoryPop from "../Modals/reportStoryPop";

export default function StoryCard({ story = {}, handleReactionsList = () => {}, storyType = "" }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { myStoriesList = {}, privateStoriesList = {} } = useSelector(
    (state) => state.stories || {}
  );
  const [userAction, setUserAction] = useState(null);

  const getStoriesList = () => {
    if (storyType === "private") return privateStoriesList;
    if (storyType === "myStories") return myStoriesList;
  };

  const handleUpdateStoriesList = () => {
    const index = getStoriesList().records?.findIndex((item) => item._id === story._id);
    const oldStories = [...(getStoriesList().records || [])];

    if (index >= 0) {
      oldStories.splice(index, 1);
    }

    dispatch(
      updateStoriesList({
        listFor: storyType,
        records: oldStories,
        totalCount: getStoriesList().totalCount - 1,
      })
    );
  };

  const handleDelete = async () => {
    const response = await handleApiRequest(deleteStory, { storyId: story._id });
    if (response.status) {
      successMsg("Story deleted successfully");
      handleUpdateStoriesList();
    }
  };

  return (
    <>
      <div
        className="mainStoryCard rounded pointer mb-2 py-3 px-2 px-lg-3"
        onClick={() => navigate(`${storyDetailsRoute}/${getSlug(story.title)}/${story._id}`)}>
        <StoryCardHeader
          story={story}
          storyType={storyType}
          showStatus={storyType === "myStories"}
          setUserAction={setUserAction}
        />

        <h4 className="my-2 my-lg-3">{story.title}</h4>
        <div
          className="storyDesc truncate-3"
          dangerouslySetInnerHTML={{ __html: story.description }}
        />

        <div className="storyAction d-flex align-items-center justify-content-between mt-3">
          <div className="d-flex align-items-center">
            <p
              className="min-w-50 btn justify-content-center bg-header border-secondary-light me-2 px-2 ps-sm-2 pe-sm-3 py-2 rounded-pill text-small"
              onClick={(e) => e.stopPropagation()}>
              <span
                dangerouslySetInnerHTML={{ __html: story.category?.iconFilled }}
                className="reactedIcon"
              />
              <span className="d-none d-sm-inline-block">{story.category?.name}</span>
            </p>
            {storyType !== "private" && (
              <button
                className="min-w-50 justify-content-center bg-header border-secondary-light ms-0 me-2 px-2 ps-sm-2 pe-sm-3 py-2 rounded-pill text-small"
                onClick={(e) => {
                  e.stopPropagation();
                  if (story?.reactionsCount > 0) {
                    handleReactionsList({ action: "showReactionsList", storyId: story._id });
                  }
                }}>
                <span className="reactedIcon">
                  <LikeIcon />
                </span>
                <span>{story?.reactionsCount || 0}</span>
              </button>
            )}
            {storyType !== "private" && (
              <button
                className="mainStoryCardAction min-w-50 mx-0 justify-content-center bg-header border-secondary-light me-2 px-2 ps-sm-2 pe-sm-3 py-2 rounded-pill text-small"
                onClick={(e) => {
                  e.stopPropagation();
                  setUserAction({ action: "showSharePop" });
                }}>
                <span>
                  <ShareIcon className="width-20 height-20" />
                </span>
                <span className="d-none d-sm-inline-block">Share</span>
              </button>
            )}
          </div>
          <div className="mainStoryCardAction d-flex align-items-center gap-10">
            <button
              className="bg-header border-secondary-light d-flex align-items-start rounded px-2 px-sm-3 py-1"
              onClick={(e) => {
                e.stopPropagation();
                navigate(`${editStoryRoute}/${story._id}`);
              }}>
              <span className="me-1 d-none d-sm-inline-block"> Edit</span>
              <EditIcon className="width-20 height-20" />
            </button>
            {story.status !== "deleted" && (
              <button
                className="bg-danger border border-danger rounded px-2 px-sm-3 py-1 text-white d-flex align-items-center"
                onClick={(e) => {
                  e.stopPropagation();
                  setUserAction({ action: "deletePost" });
                }}>
                <span className="d-none d-sm-inline-block">Delete</span>
                <DeleteIcon className="width-20 height-20" />
              </button>
            )}
          </div>
        </div>
      </div>

      {userAction?.action === "deletePost" && (
        <DeletePopup
          userAction={userAction}
          setUserAction={setUserAction}
          onSubmit={handleDelete}
        />
      )}

      {userAction?.action === "showSharePop" && (
        <SharePop
          userAction={userAction}
          setUserAction={setUserAction}
          title="Share Story"
          link={window.location.href}
        />
      )}

      {userAction?.action === "reportStory" && (
        <ReportStoryPop userAction={userAction} setUserAction={setUserAction} />
      )}
    </>
  );
}
